module.exports = __webpack_public_path__ + "static/img/img01.8ea163b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/img01.png
// module id = 4Umi
// module chunks = 1